/**
 * @file ナビゲーションメニュー。TOPページでは各セクションへのスムーズスクロール、
 *        それ以外のページではTOPへのリンク+ハッシュ遷移を行う。SNCC/FVNOでキャンペーン表示名が異なる。
 */
import Link from 'next/link';
import { Link as Scroll } from 'react-scroll';
import { useRouter } from 'next/router';
import { useRecoilValue } from 'recoil';
import { userState } from '@/states/selectors/userState';

type Navi = {
  path: string;
  name: string;
};

const Navigation = () => {
  const router = useRouter();
  const user = useRecoilValue(userState);

  const menu: Navi[] = [
    { path: 'plan', name: 'ご契約内容' },
    { path: 'billing', name: 'ご利用金額' },
    { path: 'maintenance', name: '障害・メンテナンス情報' },
    { path: 'agreement', name: '規約' },
  ];

  // SNCCとFVNOでキャンペーン表示名が異なる（SNCC:「割引情報」 / FVNO:「特典・キャンペーン情報」）
  if (user.isSncc) {
    menu.push({ path: 'campaign', name: '割引情報' });
  }
  if (user.isFvno) {
    menu.push({ path: 'campaign', name: '特典・キャンペーン情報' });
  }

  return (
    <nav role='navigation'>
      <ul className='menu'>
        {menu.map((val) => (
          <li key={val.path}>
            {/* TOPページではreact-scrollでページ内スクロール、他ページではNext.js LinkでTOPへハッシュ付き遷移 */}
            {router.pathname === '/top' ? (
              <Scroll to={val.path} smooth duration={100}>
                {val.name}
              </Scroll>
            ) : (
              <Link
                href={{
                  pathname: '/top',
                  hash: val.path,
                }}
              >
                {val.name}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
